import { BaseEditor, Editor, Element, Node, NodeEntry, Path, Range, Transforms } from 'slate'
import { Registry } from '@react-registry'
import React from 'react'
import { useSlate } from 'slate-react'

import { createRowWithColSize } from './createRowWithColSize'
import { elementCategories } from '../../elementCategories'
import { TableAddRowBeforeIcon } from '../../../utils/Icon'
import RTE_SHORTCUT from '../../../../../../../utils/common-rte-utils/shortcuts.constant'
import { cellType, isCellSpanning } from './mergeCells'
import { cloneDeep, findLast, isEqual } from 'lodash'
import { createCell } from './createCell'
import { getSpanningCell } from './helper'
import { is } from 'date-fns/locale'


export const incrementRowSpan = (editor: BaseEditor, cellEntry: NodeEntry<Node>) => {
  const [cell, path] = cellEntry
  const newAttrs = cloneDeep(cell['attrs'])
  newAttrs.rowSpan++
  newAttrs['redactor-attributes'].rowspan = newAttrs.rowSpan

  Transforms.setNodes(editor, {
    attrs: newAttrs
  } as Partial<Node>, {
    at: path
  })
}

export const insertRowBefore = (event, { editor }) => {
  const tableEntry = Editor.above(editor, {
    match: (n) => {
      return n["type"] === 'table'
    },
    mode: 'lowest'
  })

  const rowEntry = Editor.above(editor, {
    match: (n) => {
      return n["type"] === 'tr'
    },
    mode: 'lowest'
  })
  if (!tableEntry || !rowEntry) return

  if (!tableEntry || !rowEntry) return

  const cellsInCurrentRow = rowEntry[0].children.map((cell, index) => {
    return [cell, [...rowEntry[1], index]] as NodeEntry<Node>
  })

  const newRowChildren = []

  const cellsToIncrementRowSpanTo: NodeEntry<Node>[] = []

  for (const [cell, path] of cellsInCurrentRow) {
    let isVoid = false

    if (Editor.isVoid(editor, cell)) {

      const spanningCellEntry = getSpanningCell(editor, path)

      if (spanningCellEntry) {
        const [spanningCell, spanningCellPath] = spanningCellEntry
        const { hasRowSpan } = isCellSpanning(spanningCell)
        if (hasRowSpan) {
          cellsToIncrementRowSpanTo.push(spanningCellEntry)
          isVoid = true
        }
      }
    }

    let cellToInsert = createCell(cell['type'], isVoid)
    newRowChildren.push(cellToInsert)
  }

  for (const ne of cellsToIncrementRowSpanTo) {
    incrementRowSpan(editor, ne)
  }

  Transforms.insertNodes(editor, {
    type: 'tr',
    attrs: {},
    children: newRowChildren
  } as Node, {
    at: rowEntry[1]
  })

  Transforms.setNodes(
    editor,
    {
      attrs: {
        ...tableEntry[0]["attrs"],
        rows: tableEntry[0]["attrs"].rows + 1
      }
    } as Partial<Node>,
    { at: tableEntry[1] }
  )

}
const InsertRowTopButton = (props) => {
  const editor = useSlate()
  return (
    <React.Fragment>
      {props.children({
        handleMouseDown: insertRowBefore,
        isDisable: {
          func: insertRowBeforeButtonDisabler,
          params: { editor },
        },
        additionalParams: { editor },
      })}
    </React.Fragment>
  )
}

const shortcutInsertRowBefore = (event, editor, format, registryObj) => {
  insertRowBefore(event, { editor })
}
export const insertRowBeforeButtonDisabler = ({ editor }) => {

  if (editor.selection && Range.isExpanded(editor.selection)) return true

  const [table] = Editor.nodes(editor, {
    match: (n) => {
      return n['type'] === 'table'
    },
    mode: 'lowest',
  })


  return !table
}
Registry.register(
  {
    iconName: <TableAddRowBeforeIcon />,
    IngressComponent: InsertRowTopButton,
    category: elementCategories.TABLE_ACTION,
    toolbar: {
      inSlashToolbar: false,
    },
    shortcut: { key: RTE_SHORTCUT.ADD_ROW_ABOVE, callback: shortcutInsertRowBefore },
    canCustomize: false,
    title: 'Insert row above',
    isContentStackElement: true,
  },
  {
    id: 'table-insert-row-top',
    registry: 'element',
  }
)
